import { render, staticRenderFns } from "./NoTaskCosts.vue?vue&type=template&id=fc18b952&scoped=true&"
import script from "./NoTaskCosts.vue?vue&type=script&lang=js&"
export * from "./NoTaskCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc18b952",
  null
  
)

export default component.exports